import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThefork = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "2 3 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.00001 12.084C2.00498 7.55626 5.41607 3 12.1309 3C18.6708 3 22.0755 7.60709 21.9987 11.9702C21.9099 17.028 18.4533 19.6443 15.3571 20.5849L15.0038 19.0769C14.8197 18.2863 15.0386 17.581 15.6124 17.0825C16.3532 16.4379 16.7947 15.6408 17.0243 14.5387C17.2667 13.3735 17.153 12.0947 16.6141 10.8174L14.7827 5.79392H12.9456L14.4137 11.5324C14.5481 12.1039 14.103 12.649 13.5016 12.649L11.7178 5.01907H10.0486L11.6546 14.4352C10.6486 14.5232 10.2761 13.8869 10.1929 13.4264L9.16841 6.31489H7.47211C7.47211 6.31489 7.48277 10.1461 7.48277 12.7626C7.48277 16.6082 9.59 17.753 11.0453 18.0945C11.8686 18.2876 12.4188 18.9121 12.5681 19.7888L12.775 21C9.65753 21.0078 1.99148 19.8762 2.00001 12.084Z",
		fill: "#00665C"
	})]
});
const ForwardRef = forwardRef(SvgThefork);
export { ForwardRef as ReactComponent };
